var index = {
    data() {
        return {
            apps: [],
            configs: [],
            configitems: []
        }
    },
    fetch() {
        this.$api.app.getappdata().then((res) => {
            if (res.R && res.data) {
                var d = res.data;
                if (d.apps)
                    this.apps = d.apps;
                if (d.configs)
                    this.configs = d.configs;
                if (d.configItems)
                    this.configitems = d.configItems;
            }
        })
    }
}

export default index;